import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../../routes/Routes';
import CustomAxios from '../../../../utility/customAxios';

export const postOutlookAuthCode = async (code: string) => {
  const response = await CustomAxios.post(`integrations/outlook/callback`, { code });
  const { data } = response;
  return data;
};

export function useCreateOutlookAuth() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (code: string) => postOutlookAuthCode(code),
    onSuccess: () => {
      navigate(`/${ROUTE_PATHS.INTEGRATIONS}`);
    },
    onError: (err: AxiosError) => {
      console.error('Error saving token:', err);
      navigate('/');
    },
  });
}
